<template>
  <Component :is="mainComponent"/>
</template>

<script>
import { mapGetters } from 'vuex'
import DashboardDefault from '@/views/DashboardDefault.vue'
// import DashboardInsights from '@/views/DashboardInsights.vue'
import InsightConversations from '@/views/InsightConversations.vue'

export default {
  name: 'Dashboard',

  components: {
    DashboardDefault,
    // DashboardInsights,
    InsightConversations
  },

  computed: {
    ...mapGetters('auth', ['userRole']),
    ...mapGetters(['quicksightPlatforms']),

    mainComponent () {
      return this.userRole === 'platform'
        ? 'InsightConversations'
        : 'DashboardDefault'
    }
  }
}
</script>
